import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReviewTargetModel } from '@models/index';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'review-targets-card',
  templateUrl: './review-targets-card.component.html',
  styleUrls: ['./review-targets-card.component.sass']
})
export class ReviewTargetstCardComponent implements OnInit {

  @Input() reviewTarget: ReviewTargetModel;
  @Output() edit = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() onChangeSwitch = new EventEmitter();
  @Output() changeName = new EventEmitter();
  focus = false

  previousName: string;

  editNameFlag: boolean = false;

  constructor() { }

  ngOnInit() {

    this.previousName = this.reviewTarget.name;
  }

  onFocus() {
      this.focus = true
  }
  onBlur() {
    setTimeout(()=>{
      this.focus = false;
      if(!this.editNameFlag)this.resetName()
    },500)
  }

  resetName(){
    this.editNameFlag = false;
    this.reviewTarget.name = this.previousName;
  }

  editName(){
    this.editNameFlag = true;
    this.changeName.emit();
  }

  onCheck(e) {
    e.stopPropagation()
  }

  deleteClick() {
    Swal.fire({
      title: 'Delete Review Site',
      text: `Are you sure you want to delete the ${this.reviewTarget.name} Review Site?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: '#d33',
    }).then(result => {
      if (result.value) {
        this.delete.emit()
      }
    })
  }

  OnBeforeChange: Observable<boolean> = Observable.create((observer) => {
    if(this.reviewTarget.enable) {
      Swal.fire({
        title: 'Disable Review Site',
        text: `Are you sure you want to disable the ${this.reviewTarget.name} Review Site?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, disable it!'
      }).then(result => {
        if (result.value) {
          observer.next(true);
          this.onChangeSwitch.emit()
        }
      })
    } else {
      observer.next(true);
      this.onChangeSwitch.emit()
    }
  });

}
